import Vue from 'vue'
import { HTTP } from "@/services/HTTPService"
import store from '../../store'

export default {
  async getWorkWeeks(mimk, week_start, week_end, segment) {
    const segmentState = store.state.user.segment
    const params = {
      mimk,
      week_start,
      week_end,
      segment: segment || segmentState.id,
      tz_offset: segmentState.tz_offset
    }
    const response = await HTTP.get('/work_weeks/', {params})
    return response.data
  },

  async getWorkWeeksM1(m1, week_start, week_end, segment) {
    const segmentState = store.state.user.segment
    const params = {
      m1,
      week_start,
      week_end,
      segment: segment || segmentState.id,
      tz_offset: segmentState.tz_offset
    }
    const response = await HTTP.get('/work_weeks_m1/', {params})
    return response.data
  },

  async duplicateWorkWeek(id, mimk, mimk_name, mimk_rating, week_starts_at, week_ends_at, work_week) {
    try {
      const segmentState = store.state.user.segment

      const params = {
        mimk,
        mimk_name,
        mimk_rating: mimk_rating || 1,
        week_starts_at,
        week_ends_at,
        work_week,
        segment: segmentState.id
      }
      const response = await HTTP.post(`/work_weeks/duplicate/?tz_offset=${segmentState.tz_offset}`, params)
      if (response) {
        Vue.toasted.global.all_ok('Расписание Скопировано на следующую неделю')
      }
      return response
    } catch (err) {throw Error(err)}
  },

  async duplicateWorkWeekM1(id, m1, m1_name, m1_rating, week_starts_at, week_ends_at, work_week) {
    try {
      const segmentState = store.state.user.segment

      const params = {
        m1,
        m1_name,
        m1_rating: m1_rating || 1,
        week_starts_at,
        week_ends_at,
        work_week,
        segment: segmentState.id
      }
      const response = await HTTP.post(`/work_weeks_m1/duplicate/?tz_offset=${segmentState.tz_offset}`, params)
      if (response) {
        Vue.toasted.global.all_ok('Расписание Скопировано на следующую неделю')
      }
      return response
    } catch (err) {throw Error(err)}
  },

  async changeWorkWeeks(id, mimk, mimk_name, mimk_rating, week_starts_at, week_ends_at, work_week, isAddTime) {
    const segmentState = store.state.user.segment
    const toast = Vue.toasted.global
    const params = {
      mimk,
      mimk_name,
      mimk_rating: mimk_rating || 1,
      week_starts_at,
      week_ends_at,
      work_week,
      segment: segmentState.id
    }
    try {
      const response = await HTTP.put(`/work_weeks/${id}`, params)
      if (response) {
        isAddTime ? toast.all_ok(`Запись создана`) : toast.all_ok(`Запись удалена`)
      }
      return response
    } catch (err) {throw Error(err)}
  },

  async changeWorkWeeksM1(id, m1, m1_name, m1_rating, week_starts_at, week_ends_at, work_week, isAddTime) {
    const segmentState = store.state.user.segment
    const toast = Vue.toasted.global
    const params = {
      m1,
      m1_name,
      m1_rating: m1_rating || 1,
      week_starts_at,
      week_ends_at,
      work_week,
      segment: segmentState.id
    }
    try {
      const response = await HTTP.put(`/work_weeks_m1/${id}`, params)
      if (response) {
        isAddTime ? toast.all_ok(`Запись создана`) : toast.all_ok(`Запись удалена`)
      }
      return response
    } catch (err) {throw Error(err)}
  },

  async getWorkHoursTypes() {
    const response = await HTTP.get('/mimk/work_hour_types/')
    return response.data
  },

  async getWorkHoursTypesM1() {
    const response = await HTTP.get('/m1/work_hour_types/')
    return response.data
  }
}
